// The Font Awesome icons this app actually uses, for `library.add`.
//
// Registering whole sets (`library.add(fas, far, fad)`) defeats tree-shaking and bundles
// ~2.3 MB gzipped of icons to render a few hundred. These two lists are the icons found in
// markup by bin/fa-icons plus the runtime-assembled ones tracked by hand.

import { dynamicIcons } from './dynamic_icons';
import { generatedIcons } from './generated_icons';

export const icons = [...generatedIcons, ...dynamicIcons];
